__webpack_require__.p = "/bankportal/";